import invariant from 'tiny-invariant'
import { Currency } from './currency'
import { NativeCurrency } from './nativeCurrency'
import { Token } from './token'
import { WBNB } from './wbnb'

/**
 * Bnb is the main usage of a 'native' currency, i.e. for Ethereum mainnet and all testnets
 */
export class BNB extends NativeCurrency {
  protected constructor(chainId: number) {
    super(chainId, 18, 'BNB', 'Binance Coin')
  }

  public get wrapped(): Token {
    const wbnb = WBNB[this.chainId]
    invariant(!!wbnb, 'WRAPPED')
    return wbnb
  }

  private static _etherCache: { [chainId: number]: BNB } = {}

  public static onChain(chainId: number): BNB {
    return this._etherCache[chainId] ?? (this._etherCache[chainId] = new BNB(chainId))
  }

  public equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }
}
